import React, {useEffect, useState} from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types'
import BaseParagraph from "components/base-components/base-paragraph";
import InputField from "components/base-components/base-input";
import StepsLoader from "steps/steps-loader";
import StepFooterAction from "components/base-components/step-footer-action";
import getStep from '../../../helpers/getStep';
import { BASE_URL } from '../../../env';
        




const TelephoneStep = ({_step_service, step_ID, next_step, step_URL, error, setDataToContext, getDataFromContext, step_form}) => {
    const countryService = `${BASE_URL}/onboarding-entrepreneur-front/v1/countries/`
    const lang = localStorage.getItem('language')

    const data = getDataFromContext(step_ID)
    const [inputData, setInputData] = useState({ ...data })
    const [isValid, setIsValid] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [emailOptin, setEmailOptin] = useState(false)

    const getInputValue = (name, value) => {
            setInputData({
            ...inputData,
            [name] : value
        })
        setDataToContext(step_ID, step_URL, name, value)        
    }

    const isValidForm = () => {
        const val = inputData.internal_mobile_phone_number
        return val && val.length >= 5 && !val.includes("_")
    } 

    const action = () => {
        _step_service({step_ID, setIsLoading,next_step})
    }

    useEffect(() => {
        setIsValid(isValidForm())
    }, [inputData])

    useEffect(() => {
        console.log("data => ", data)
        getStep("optin_email").then(({ fieldValue }) => setEmailOptin(fieldValue == 1))      
         if (window.PageBus) {
            window.PageBus.publish(
                "analyticsServices", {
                    pageID: "onboarding",
                    stepSeq: "1",
                    stepName: "personal info:phone number",
                    flowType: "sales",
                    flowName: "onboarding",
                    productName: "onboarding",
                    visualisationType: emailOptin ? "email communication authorised" :"email communication unauthorised",
                    trackMethod: "flow"
            }
            );
        }

        async function fetchCountry() {
        const res = await (await fetch(`${countryService}${lang}`)).json()
        const reRes = res.map(ctr => ({
            name: ctr.title,
            callingCode: ctr.phoneCode,
            code: ctr.iso2,
            isDefault: ctr.isDefault,
            priority: ctr.priority,
            translation: {
                de: ctr.title,
                fr: ctr.title,
                nl: ctr.title
            }
        }))
        const ordinaryList = reRes.filter(ctr => (ctr.priority === 0))
        const popularList = reRes.filter(ctr => (ctr.priority !== 0))
        const fullList = reRes
   
        }
        fetchCountry()
    }, [])

    return (
        <>
            <StepsLoader loading={isLoading}>
                <form>
                    <BaseParagraph>
                        <h3>{t('personal_infos.personal_info_phone_number.title')}</h3>
                        <p>{t('personal_infos.personal_info_phone_number.text')}</p>
                    </BaseParagraph>

                    {step_form.map(input => (<InputField
                        id={input.id}
                        name={input.id}
                        error={error}
                        type={input.type}
                        value={inputData[input.id]}
                        max={input.max}
                        checked={inputData[input.id]}
                        phoneCode={inputData}
                        { ...(input.label && { checkboxLabel: t(input.label) })  }
                        getInputValue={getInputValue}
                        key={input.id}/>))}

                    <StepFooterAction caption={t('general.continue')} action={action} link={next_step} disabled={!isValid} />
                    {/* <StepFooterAction caption={"skip"} action={skip} link={next_step} /> */}
                    

                </form>
            </StepsLoader>


        </>
    )
}

TelephoneStep.propTypes = {
    name: PropTypes.string,
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
    error: PropTypes.array,
    next_step: PropTypes.string,
    _step_service: PropTypes.func,
}

TelephoneStep.defaultProps = {
    name: "email-step"
}


export default TelephoneStep